<template>
    <div id="login" class="">
        <form @submit.prevent="login" class="login_form" :class="{'is-loading' : isRequesting }">
            <label class="field_wrap" :class="{'has-error' : loginError}">
                <input @focus="inputActivate"
                       @blur="inputDeactivate" type="text"
                       name="username"
                       v-model.trim="username" /><span>Benutzername</span></label>
            <label class="field_wrap" :class="{'has-error' : loginError}">
                <input @focus="inputActivate"
                       @blur="inputDeactivate" type="password"
                       name="password"
                       v-model.trim="password" /><span>Passwort</span></label>

            <button type="submit" class="login-button" v-on:animationend="goToMain">
                <logo :color="buttonColor" name="login" :width=105 :height=105></logo>
            </button>
        </form>
    </div>
</template>

<script>
	import { AUTH_REQUEST } from "../utils/store/actions/auth";
	import SvgImage from "./subparts/SvgImage";

	export default {
		name: "KappLogin",
		data() {
			return {
				username: '',
				password: '',
				loginError: false,
				isRequesting: false,
				buttonImage: require('@/assets/images/logo_grey.svg')
			};
		},
		components: {
			'logo': SvgImage
		},
		props: [],
		computed: {
			buttonColor() {
				return this.isRequesting ? 'red' : 'standard';
			}

		},
		methods: {
			goToMain: function () {
				if ( this.$store.getters.isAuthenticated ) this.$router.push({name: 'MainView'});
			},
			usernameValid: function ( notEmpty = false ) {
				let isValid = true;

				if ( this.username.length < 4 )
					isValid = false;

				/** exceptions */
				if ( !notEmpty && this.username.length === 0 )
					isValid = true;

				return isValid;
			},
			passwordValid: function ( notEmpty = false ) {
				let isValid = true;

				if ( this.password.length < 4 )
					isValid = false;

				/** exceptions */
				if ( !notEmpty && this.password.length === 0 )
					isValid = true;

				return isValid;
			},
			login: function ( evt ) {
				const {username, password} = this;

				if ( this.usernameValid(true) && this.passwordValid(true) ) {
					this.isRequesting = true;
					this.$store.dispatch(AUTH_REQUEST, {username, password})
					    .then(() => {
						    this.isRequesting = false;
						    this.$router.push({name: 'MainView'});
					    })
					    .catch(( err ) => {
						    this.isRequesting = false;
						    this.loginError = true;
						    console.warn(err);
					    });
				}
				else {
					this.loginError = true;
					console.warn('Credentials are invalid');
				}
			},
			inputActivate: function () {
				document.querySelector('body').style.overflow = 'auto';
			},
			inputDeactivate: function () {
				document.querySelector('body').style.overflow = 'hidden';
			}
		},
		watch: {
			username: function( val ) {this.loginError = false},
			password: function( val ) {this.loginError = false}
		}
	};
</script>

<style scoped>
    :root {
        --color-error: #E4223C;
    }


    .login-button > * {
        vertical-align: middle;
        width: 105px;
        height: 105px;
        animation: sizeInButton .8s ease-out forwards;
    }

    .login_form.is-loading .field_wrap {
        visibility: hidden;
    }

    .login_form.is-loading button {
        border-radius: 50%;
        animation: pulseColor 1.5s .3s ease-in-out alternate 1;
    }

    @keyframes sizeInButton {
        from {
            transform: scale(.8095238);
        }
    }

    @keyframes pulseColor {
        0% {
            box-shadow: 0 0 80px rgba(228, 34, 60, .0);
        }
        50% {
            box-shadow: 0 0 80px rgba(228, 34, 60, .7);
            transform: scale(1.19047619047619);
        }
        100% {
            box-shadow: 0 0 80px rgba(228, 34, 60, .4);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/KappLogin.vue